if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
		constructor() {
			super();

			this.form = this.querySelector("form");
			this.form.querySelector("[name=id]").disabled = false;
			this.form.addEventListener(
				"submit",
				this.onSubmitHandler.bind(this)
			);
			this.cart =
				document.querySelector("cart-drawer") ||
				document.querySelector("cart-notification");
			this.submitButton = this.querySelector('[type="submit"]');
			this.submitButtonText = this.submitButton.querySelector("span");

			if (document.querySelector("cart-drawer"))
				this.submitButton.setAttribute("aria-haspopup", "dialog");

			this.hideErrors = this.dataset.hideErrors === "true";
		}

		async onSubmitHandler(evt) {
			evt.preventDefault();
			if (this.submitButton.getAttribute("aria-disabled") === "true")
				return;

			this.handleErrorMessage();
			this.submitButton.setAttribute("aria-disabled", true);
			this.submitButton.classList.add("loading");
			this.querySelector(".loading__spinner").classList.remove("hidden");

			try {
				// Fetch cart to get igTestGroups attribute
				const cartResponse = await fetch(`${routes.cart_url}.js`);
				const cartData = await cartResponse.json();
				
				// Get igTestGroups from cart attributes
				const igTestGroups = cartData.attributes?.igTestGroups;

				const config = fetchConfig("form");
				const formData = new FormData(this.form);

				// Add igTestGroups as a property to line items
				if (igTestGroups) {
					formData.append("properties[_igTestGroups]", igTestGroups);
				}

				// Add required sections for cart drawer
				formData.append("sections", "cart-drawer,cart-icon-bubble");

				config.body = formData;

				fetch(`${routes.cart_add_url}`, config)
					.then(response => response.json())
					.then(response => {
						if (response.status) {
							publish(PUB_SUB_EVENTS.cartError, {
								source: "product-form",
								productVariantId: formData.get("id"),
								errors: response.errors || response.description,
								message: response.message,
							});
							this.handleErrorMessage(response.description);

							const soldOutMessage =
								this.submitButton.querySelector(".sold-out-message");
							if (!soldOutMessage) return;
							this.submitButton.setAttribute("aria-disabled", true);
							this.submitButtonText.classList.add("hidden");
							soldOutMessage.classList.remove("hidden");
							this.error = true;
							return;
						}

						if (!this.error) {
							const eventData = {
								source: "product-form",
								productVariantId: formData.get("id"),
								cartData: response,
								isPrimaryUpdate: true,
							};

							if (
								window.analytics &&
								typeof window.analytics.track === "function"
							) {
								window.analytics.track("Added to Cart", {
									productId: formData.get("id"),
									source: "product-form",
								});
							}

							publish(PUB_SUB_EVENTS.cartUpdate, eventData);
						}

						this.error = false;
						const quickAddModal = this.closest("quick-add-modal");

						if (quickAddModal) {
							document.body.addEventListener(
								"modalClosed",
								() => {
									setTimeout(() => {
										if (
											this.cart &&
											typeof this.cart.renderContents === "function"
										) {
											this.cart.renderContents(response);
										} else {
											// Fallback if cart methods aren't available
											window.location = window.routes.cart_url;
										}
									});
								},
								{ once: true }
							);
							quickAddModal.hide(true);
						} else if (
							this.cart &&
							typeof this.cart.renderContents === "function"
						) {
							this.cart.renderContents(response);
						} else {
							// Fallback if cart methods aren't available
							window.location = window.routes.cart_url;
						}
					})
					.catch(e => {
						console.error(e);
						const errorMessage = e.toString();
						this.handleErrorMessage(errorMessage);
					})
					.finally(() => {
						this.submitButton.classList.remove("loading");
						if (this.cart && this.cart.classList.contains("is-empty"))
							this.cart.classList.remove("is-empty");
						if (!this.error)
							this.submitButton.removeAttribute("aria-disabled");
						this.querySelector(".loading__spinner").classList.add(
							"hidden"
						);
					});
			} catch (e) {
				console.error("Error fetching cart attributes:", e);
				const errorMessage = e.toString();
				this.handleErrorMessage(errorMessage);
				this.submitButton.classList.remove("loading");
				this.submitButton.removeAttribute("aria-disabled");
				this.querySelector(".loading__spinner").classList.add("hidden");
			}
		}

		handleErrorMessage(errorMessage = false) {
			if (this.hideErrors) return;

			this.errorMessageWrapper =
				this.errorMessageWrapper ||
				this.querySelector(".product-form__error-message-wrapper");
			if (!this.errorMessageWrapper) return;
			this.errorMessage =
				this.errorMessage ||
				this.errorMessageWrapper.querySelector(
					".product-form__error-message"
				);

			this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

			if (errorMessage) {
				this.errorMessage.textContent = errorMessage;
			}
		}

		toggleSubmitButton(disable = true, text) {
			if (disable) {
				// this.submitButton.setAttribute("disabled", "disabled");
				if (text) this.submitButtonText.textContent = text;
				console.log(text, "❤️❤️❤️")
			} else {
				// this.submitButton.removeAttribute("disabled");
				this.submitButtonText.textContent =
					window.variantStrings.addToCart;
					console.log(window.variantStrings.addToCart, "❤️❤️❤️")
			}
		}

		get variantIdInput() {
			return this.form.querySelector("[name=id]");
		}
	}
	);
}
